<script setup lang="ts">
import {computed} from "vue";

interface Props {
    date: string
    completed?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    completed: false
})

const isOverdue = computed(() => {
    if (props.completed) return false

    const now = new Date();
    const dueDate = new Date(props.date);
    return dueDate < now;
});
</script>

<template>
    <v-tooltip
        location="top"
        content-class="bg-black border-sm text-tooltip text-center"
        max-width="200"
    >
        <template #activator="{ props: bind }">
            <span
                v-bind="bind"
                class="mx-1 custom-text text-medium-emphasis text-start cursor-help font-weight-regular text-sm"
            >
                <v-icon
                    :color="isOverdue ? 'red-darken-2' : 'black'"
                    size="small"
                    class="mr-1"
                >
                    {{ isOverdue ? 'mdi-calendar-remove' : 'mdi-calendar' }}
                </v-icon>
                <slot />
            </span>
        </template>
        {{ isOverdue ? 'Overdue' : 'Due on' }}
    </v-tooltip>
</template>

<style scoped>
</style>
